<div class="landing">
  <div id="page-wrapper">

    <!-- Header -->
    <header id="header" class="alt">
      <h1><a href="index.html">JanguKit</a> by Vulcanalia</h1>
      <nav id="nav">
        <ul>

          <li><a href="#pricing" class="icon fa-angle-down">Pricing</a></li>
          <li><a href="#features" class="icon fa-angle-down">Features</a></li>
          <li><a href="#" class="icon fa-angle-down">Demo</a></li>

          <li><a class="button special" (click)="navigate('subscribe');" translate>home.subscribe</a></li>
          <li><a class="button" (click)="navigate('login');" translate>home.login</a></li>
        </ul>
      </nav>
    </header>

    <!-- Banner -->
    <section id="banner">
      <div class="coffee-icon-container">
        <img src="assets/espresso-coffee.svg" alt="" height="50px" class="coffee-icon"/>
      </div>
      <h2>JanguKit</h2>
      <p  class="slogan-content" translate>home.slogan</p>
      <ul class="actions">
        <li>
          <a class="button special" (click)="navigate('subscribe');" translate>
            <img src="assets/espresso-coffee.svg" alt="" height="25px" class="coffee-icon-black"/>
            home.subscribe
          </a>
        </li>
        <!--
                <li><a class="button" (click)="navigate('login');" translate>home.login</a></li>
        -->
      </ul>
    </section>


    <!-- Main -->
    <section id="main" class="container">

      <section class="box special">
        <header class="major">
          <h2 translate>home.h2</h2>
          <p class="intro" translate>home.intro</p>
        </header>
      </section>

      <section id="features" class="box special features">
        <h2 class="">Focus on your main feature, we provide the rest !</h2>
        <div class="features-container">
          <div class="features-row">
          <section>
								<span class="icon major fa-bolt accent2">
                  <mat-icon class="icon-home-page">
                    payment
                    </mat-icon>
                </span>
            <h3>Manage payment</h3>
            <p>Stripe payment and subscriptions billing easily </p>
          </section>
          <section>
								<span class="icon major fa-area-chart accent3">
                   <mat-icon class="icon-home-page">
                      supervised_user_circle
                      </mat-icon>
                </span>
            <h3> User management</h3>
            <p>Multiple user authentification methods: Google, Linkedin...</p>
          </section>
        </div>
          <div class="features-row">
          <section>
								<span class="icon major fa-cloud accent4">
                  <mat-icon class="icon-home-page">
                      alternate_email
                      </mat-icon>
                </span>
            <h3>Mailing solutions</h3>
            <p>
              JanguKit is integrated with different mailing solutions. You can send emails to your customers directly
              from the platform.
            </p>

          </section>
          <section>
								<span class="icon major fa-lock accent5">
                  <mat-icon class="icon-home-page">
                      question_answer
                      </mat-icon>
                </span>
            <h3>Feedback and Request</h3>
            <p>JanguKit gathers your customers feedback and requests </p>
          </section>
        </div>
        </div>
      </section>

      <div class="row">
        <div class="6u 12u(narrower)">

          <!--<section class="box special">
            <h3>Sed lorem adipiscing</h3>


            <ul class="actions">
              <li><a href="#" class="button alt">Learn More</a></li>
            </ul>
          </section>-->

        </div>
        <!-- <div class="6u 12u(narrower)">

           <section class="box special">
             <h3>Accumsan integer</h3>
             <p>Integer volutpat ante et accumsan commophasellus sed aliquam feugiat lorem aliquet ut enim rutrum phasellus iaculis accumsan dolore magna aliquam veroeros.</p>
             <ul class="actions">
               <li><a href="#" class="button alt">Learn More</a></li>
             </ul>
           </section>

         </div>-->
      </div>

    </section>

    <section id="techno">

    </section>

    <!-- CTA -->
    <section id="cta">

      <h2>All your favourite frameworks are already set up !</h2>
      <div class="techno-container">
        <img src="assets/java.svg" height="120px" alt=""/>
        <img src="assets/spring.svg" height="120px" alt=""/>
        <img src="assets/typescript.svg" height="120px" alt=""/>
        <img src="assets/angular_icon_gradient.gif" height="120px" alt=""/>
        <img src="assets/Liquibase.png" height="100px" alt=""/>
        <img src="assets/docker.svg" height="120px" alt=""/>
        <img src="assets/github.svg" height="120px" alt="" class="filter-green"/>
      </div>
      <!--<p>Bl&ndash;&gt;andit varius ut praesent nascetur eu penatibus nisi risus faucibus nunc.</p>

      <form>
        <div class="row uniform 50%">
          <div class="8u 12u(mobilep)">
            <input type="email" name="email" id="email" placeholder="Email Address" />
          </div>
          <div class="4u 12u(mobilep)">
            <input type="submit" value="Sign Up" class="fit" />
          </div>
        </div>
      </form>-->

    </section>

    <section id="pricing">

      <h2 class="">Make your time count. Take action. Now !</h2>

      <div class="pricing-container">
        <div class="pricing">
          <div class="title">Starter</div>
          <div class="amount">
            <div class="original-price">$249</div>
            <div class="current-price">$149</div>
          </div>
          <div class="features">
            <ul>
              <li>Fully integrated Stripe Payment System</li>
              <li>Multiple User Authentication methods</li>
              <li>Customer Feedback and Requests</li>
              <li>Customizable Dashboard</li>
              <li>RGPD Compliant</li>
            </ul>
          </div>

          <div class="buttomn-container">
            <a class="button special" (click)="navigate('subscribe');" translate>
              <img src="assets/espresso-coffee.svg" alt="" height="25px" class="coffee-icon-black"/>
              home.subscribe
            </a>
          </div>
        </div>


    <!--    <div class="pricing">
          <div class="title">Elite</div>
          <div class="amount">
            <div class="original-price">$349</div>
            <div class="current-price">$249</div>
          </div>
          <div class="features">
            <ul>
              <li>Fully integrated Stripe Payment System</li>
              <li>Multiple User Authentication methods</li>
              <li>User Teams Management</li>
              <li>Customer Feedback and Requests</li>
              <li>Customizable Dashboard</li>
              <li>Video courses to explain how to use JanguKit</li>
              <li>Customer Support to help you launch</li>
            </ul>
          </div>
          <div class="buttomn-container">
            <a class="button special" (click)="navigate('subscribe');" translate>
              <img src="assets/espresso-coffee.svg" alt="" height="25px" class="coffee-icon-black"/>
              home.subscribe
            </a>
          </div>
        </div>-->


      </div>

    </section>
    <!-- Footer -->
    <footer id="footer">
      <div class="footer-first">
        <div class="footer-logo">
          <img src="assets/espresso-coffee.svg" alt="" height="20px" class="coffee-icon"/>
          <p class="title-logo">JanguKit</p>
        </div>
        <div  class="footer-section">
          <p class="footer-section-title">Links</p>
          <ul>
            <li><a href="#">Features</a></li>
            <li><a href="#">Pricing</a></li>
            <li><a href="#">Documentation</a></li>
            <li><a href="#">Blog</a></li>
          </ul>
        </div>
        <div  class="footer-section">
          <p class="footer-section-title">Legal</p>
          <ul>
            <li><a (click)="navigate('terms-of-use');">Terms of Use</a></li>
            <li><a (click)="navigateToAnchor('terms-of-use', 'privacy');">Privacy Policy</a></li>
            <li><a (click)="navigateToAnchor('terms-of-use', 'cookies');">Cookie Policy</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <p class="footer-section-title">Social</p>
          <ul>
            <li><a href="#">Linkedin</a></li>
            <li><a href="#">X</a></li>
          </ul>
        </div>
      </div>
      <ul class="icons">
        <li><a href="#" class="icon fa-twitter"><span class="label">Twitter</span></a></li>
        <li><a href="#" class="icon fa-facebook"><span class="label">Facebook</span></a></li>
        <li><a href="#" class="icon fa-instagram"><span class="label">Instagram</span></a></li>
        <li><a href="#" class="icon fa-github"><span class="label">Github</span></a></li>
        <li><a href="#" class="icon fa-dribbble"><span class="label">Dribbble</span></a></li>
        <li><a href="#" class="icon fa-google-plus"><span class="label">Google+</span></a></li>
      </ul>
      <ul class="copyright">
        <li>&copy; JanguKit. All rights reserved.</li>
        <li>Designed by Vulcanalia</li>
      </ul>
    </footer>

  </div>


</div>

